import {
    hasDeprecatedConfigKeys,
    populateConfigWithDefaults,
    removeDeprecatedConfigKeys
} from "./config/localStorageConfig";

export function register(config) {

    const _config = config;
    const _logPrefix = '[DAMS][service worker] - '

    function _convertConfigToSingleObject() {
        if (hasDeprecatedConfigKeys()) {
            removeDeprecatedConfigKeys();
            populateConfigWithDefaults();
            _consoleLog('default config. values loaded');
        }
    }

    function _consoleLog(message, level = null) {
        if (level === 'warn') {
            console.warn(_logPrefix + message);
        } else if (level === 'error') {
            console.error(_logPrefix + message);
        } else {
            console.log(_logPrefix + message);
        }
    }

    async function _onLoadListener() {
        const swUrl = `${import.meta.env.BASE_URL}service-worker.js`;
        if (isLocalhost) {
            // This is running on localhost. Let's check if a service worker still exists or not.
            await _checkValidServiceWorker(swUrl, _config);
            await navigator.serviceWorker.ready;
            _consoleLog('service worker ready')
        } else {
            // Is not localhost. Just register service worker
            await _registerValidSW(swUrl, _config);
        }
    }

    async function _registerValidSW(swUrl, config) {
        try {
            const registration = await navigator.serviceWorker.register(swUrl);
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (installingWorker == null) {
                    return;
                }
                installingWorker.onstatechange = () => {
                    if (installingWorker.state !== 'installed') {
                        return;
                    }

                    _convertConfigToSingleObject();

                    const controller = navigator.serviceWorker.controller;
                    if (controller) {
                        // At this point, the old content will have been purged and
                        // the fresh content will have been added to the cache.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        if (config && config.onUpdate) {
                            // New worker installed, update the config. values stored in localStorage:
                            config.onUpdate(registration);
                        }
                    } else {
                        if (config && config.onSuccess) {
                            config.onSuccess(registration);
                        }
                    }
                };
            };
        } catch (e) {
            _consoleLog(`error during service worker registration: ${e}`, 'error');
        }
    }

    async function _checkValidServiceWorker(swUrl, config) {
        const res = await fetch(swUrl, {headers: {'Service-Worker': 'script'}});
        const contentType = res.headers.get('content-type');
        if (
            res.status === 404 ||
            (contentType != null && contentType.indexOf('javascript') === -1)
        ) {
            // No service worker found. Probably a different app. Reload the page.
            const registration = await navigator.serviceWorker.ready;
            const unregistered = registration.unregister();
            if (unregistered) {
                window.location.reload();
            }
        } else {
            await _registerValidSW(swUrl, config);
        }
    }


    // Register and initialize the service worker:
    if (!('serviceWorker' in navigator)) {
        _consoleLog('service workers are not supported by this browser.');
        return;
    }

    const _publicUrl = new URL(import.meta.env.BASE_URL, window.location.href);
    if (_publicUrl.origin !== window.location.origin) {
        return;
    }

    window.addEventListener('load', _onLoadListener);
}


const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/ // NOSONAR
    )
);